import { render, staticRenderFns } from "./SearchQuanxian.vue?vue&type=template&id=6a4c259a&scoped=true"
import script from "./SearchQuanxian.vue?vue&type=script&lang=js"
export * from "./SearchQuanxian.vue?vue&type=script&lang=js"
import style0 from "./SearchQuanxian.vue?vue&type=style&index=0&id=6a4c259a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a4c259a",
  null
  
)

export default component.exports